import WidgetHostConfigResourceModel from '../../generated/types/model/resource/WidgetHostConfigResourceModel';

export default class WidgetHostConfigResourceViewModel extends WidgetHostConfigResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
